import { INotification } from '../shared/notifications.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-notification-preview',
  templateUrl: './notification-preview.component.html',
  styleUrls: ['./notification-preview.component.scss']
})
export class NotificationPreviewComponent implements OnInit {

  @Input()
  notification: INotification;

  now = Date.now();

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/notifications/notification-preview/notification-preview.component.ts